<template>
  <div class="admin-filter__item">
    <span>{{ $t(`admin.${filterName}`) }}</span>
    <div class="admin-filter-item-control">
      <el-select
          v-model="selectedValue"
          class="admin-filter__item-toggle"
          @clear="resetFilter"
          clearable
          filterable
          popper-class="admin-filter__item-popper"
          placeholder="Не выбрано">
        <el-option
            v-for="(item) in filterValues"
            :key="item.id"
            :label="item.name_ru"
            :value="item.id">
        </el-option>
      </el-select>
      <el-button
          @click="resetFilter"
      >
        <i class="el-icon-close"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {actionTypes} from '@/store/modules/admin'

export default {
  name: 'AdminPanelFilterItem',
  props: {
    filterName: {
      type: String,
      required: true,
    },
    filterValues: {
      type: Array,
      required: true,
    },
  },
  data(){
    return {
      selectedValue: ''
    }
  },
  computed: {
    ...mapState({
      selectedFilter(state) {
        let selected = 'Не выбрано'

        if (!state.admin.filter) return 'Не выбрано'

        state.admin.filter.map((filter) => {
          if (filter.by == this.filterName)
            this.filterValues.map((value) => {
              if (value.id == filter.value) {
                selected = value.name_ru
              }
            })
        })

        return selected
      },
    }),
  },
  methods: {
    resetFilter(e){
      this.$store.dispatch(actionTypes.deleteFilter, {
        filter: {by: this.filterName},
      })
      this.selectedValue = ''
    },
  },
  watch: {
    selectedValue(val){
      let filter = val
      if(filter)
      this.$store.dispatch(actionTypes.appendFilter, {
        filter: {by: this.filterName, value: filter},
      })
    }
  }
}
</script>
